export const TODAY = 'Today';
export const YESTERDAY = 'Yesterday';
export const TOMORROW = 'Tomorrow';
export const LAST_7_DAYS = 'Last 7 days';
export const LAST_14_DAYS = 'Last 14 days';
export const NEXT_5_DAYS = 'Next 5 days';
export const THIS_WEEK = 'This week';
export const THIS_MONTH = 'This month';
export const LAST_MONTH = 'Last month';
export const THIS_YEAR = 'This year';
export const LAST_6_MTHS_NEXT_6_MTHS = 'Last 6 months / Next 6 months';
export const LAST_2_YEARS_NEXT_2_YEARS = 'Last 2 years / Next 2 years';
export const LAST_7_DAYS_NEXT_5_DAYS = 'Last 7 days / Next 5 days';
